import { useContent } from "./ContentContext";

// The Blue Tequila logo (CMS-replaceable). Size controlled by the caller via className.
export const Logo = ({ className = "h-24 w-auto" }) => {
  const { settings, resolveImg } = useContent();
  const src = resolveImg(settings.images?.logo) || "/brand/logo.png";
  return (
    <img
      src={src}
      alt="Blue Tequila — Mexican Restaurant, Grill & Cantina"
      className={className}
      style={{ objectFit: "contain" }}
    />
  );
};
